import React from "react";
import Markdown from "react-markdown";
import { css } from "@emotion/css";
import { withErrorBoundary } from "../errors";
import { useTranslation } from "react-i18next";
import LastUpdated from "../components/LastUpdated";

const classes = {
    mainContent: css`
        height: 100%;
        padding: 0 20px 20px 20px;
        overflow: auto;
    `,
};

const About = () => {
    const { t } = useTranslation();

    return (
        <div className={classes.mainContent}>
            <Markdown>{t("ABOUT_1")}</Markdown>

            <Markdown>{t("ABOUT_2")}</Markdown>

            <Markdown>{t("ABOUT_3")}</Markdown>

            <Markdown>{t("ABOUT_4")}</Markdown>

            <Markdown>{t("ABOUT_5")}</Markdown>
            <ul>
                <li>
                    <Markdown>{t("ABOUT_6")}</Markdown>
                </li>
                <li>
                    <Markdown>{t("ABOUT_7")}</Markdown>
                </li>
            </ul>

            <Markdown>{t("ABOUT_8")}</Markdown>
            <ul>
                <li>
                    <Markdown>{t("ABOUT_9")}</Markdown>
                </li>
                <li>
                    <Markdown>{t("ABOUT_10")}</Markdown>
                </li>
                <li>
                    <Markdown>{t("ABOUT_11")}</Markdown>
                </li>
                <li>
                    <Markdown>{t("ABOUT_12")}</Markdown>
                </li>
            </ul>

            <Markdown>{t("ABOUT_13")}</Markdown>

            <Markdown>{t("ABOUT_14")}</Markdown>

            <p>
                <LastUpdated />
            </p>
        </div>
    );
};

export default withErrorBoundary(About);
